/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { notification } from 'antd';
import { api } from '@seaoil/component-lib';

import AsyncAutoComplete from './AsyncAutoComplete';

const { mySEAOIL } = api;

function ExpenseCategoryField({
  // attributes
  placeholder,
  disabled,

  // object attributes
  config: {
    company_code,
  },

  // methods
  onInputSelect,
}) {
  const [categories, setCategories] = useState([]);
  const [loading, isLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const retryLimit = 5;
  let retryCount = 0;

  const loadCategories = async () => {
    isLoading(true);
    try {
      const cats = await mySEAOIL.datawarehouse.getExpenseAcctEntry({
        attribute: 'category',
        parameters: { company_code },
      }).send();
      setCategories(cats);
    } catch (e) {
      if (retryCount > retryLimit) {
        notification.error({ message: 'Unable to load categories after multiple retries. Kindly contact supportdesk@seaoil.com.ph' });
      } else {
        notification.error({ message: 'Unable to load categories. Retrying after 2 seconds...' });
        setTimeout(loadCategories, 2000);
        retryCount += 1;
      }
    } finally {
      isLoading(false);
    }
  };

  useEffect(() => {
    setOptions([]);
    if (company_code) {
      loadCategories();
    }
  }, [company_code]);

  useEffect(() => {
    if (!Array.isArray(categories)) {
      return;
    }

    setOptions(categories.map(({
      category,
    }) => ({
      value: category,
      label: category,
    })));
  }, [categories]);

  return (
    <AsyncAutoComplete
      placeholder={placeholder}
      disabled={disabled}
      loading={loading}
      options={options}
      onInputSelect={(cat) => {
        if (categories) {
          onInputSelect(categories.find(({ category }) => category === cat));
        }
      }}
    />
  );
}

export default ExpenseCategoryField;
